import React, {useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import Rentals from './Rentals';
import Removal from './Removal';
import Plowing from './Plowing';

function Services() {

  const location = useLocation();
  
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 100; // Adjust this value to match your fixed header's height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }
  }, [location]);
  
  return (
    <div className="body services">
      <h1>Services</h1>
      <Rentals/>
      <Plowing/>
      <Removal/>
      
    </div>
    
  )
}

export default Services;